import { PawPrint } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden bg-navy py-3.5"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {MARQUEE_ITEMS.map((item) => (
            <span
              key={`${copy}-${item}`}
              className="flex items-center gap-6 pr-6 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.28em] text-cream/60"
            >
              {item}
              <PawPrint className="h-3.5 w-3.5 text-bark" strokeWidth={2.4} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
